// Screening copy, keyed by the stable ids the BFF returns (so clinical routing logic never
// leaks to the client). Transcribed from OPS-9280 (Tab 1). English-only literal strings, like
// the rest of this package.

const SCREENING_QUESTION_TEXT: Record<string, string> = {
  "telemedicine.screening.q.emergency":
    "Are you currently experiencing a medical emergency, such as chest pain, difficulty breathing, severe bleeding or sudden severe pain? If you are unsure, please call 911 or go to your nearest emergency room before continuing.",
  "telemedicine.screening.q.pregnant": "Are you currently pregnant?",
  "telemedicine.screening.q.comorbidities":
    "Have you been diagnosed with, or are you currently being treated for, any of the following: cancer, severe heart disease (including heart attack, stroke, or blood clots), kidney failure or dialysis, or severe liver disease/cirrhosis?"
}

export function screeningQuestionText(id: string): string {
  return SCREENING_QUESTION_TEXT[id] ?? id
}

const SCREENING_EXCLUSION_TEXT: Record<string, string> = {
  "telemedicine.screening.exclusion.emergency":
    "Based on your answer, you may be experiencing a medical emergency. Please call 911 or go to your nearest emergency room right away — this platform is not equipped to treat medical emergencies. You will not be able to schedule an appointment on this platform at this time.",
  "telemedicine.screening.exclusion.outOfScope":
    "Thank you for sharing this information. Based on your responses, your healthcare needs require a level of evaluation and management that is outside the scope of this telemedicine program. We encourage you to connect with your healthcare provider or an appropriate in-person specialist who can provide personalized care and support."
}

export function screeningExclusionText(id: string): string {
  return SCREENING_EXCLUSION_TEXT[id] ?? "Based on your responses, we're not able to book this visit right now."
}

// Heading paired with the exclusion message, chosen by whether it's an emergency.
export function screeningExclusionHeading(emergency: boolean): string {
  return emergency ? "Please seek care now" : "We're not able to book this visit"
}

export const SCREENING_ANSWER_LABELS: Record<string, string> = {
  yes: "Yes",
  no: "No"
}
